import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMap"><Path d="M2 5.95947L8 3.95947L8 18.5406L2 20.5406V5.95947Z" fill="currentColor"/><Path d="M14.5 20.054L9.5 18.5155L9.5 3.94611L14.5 5.48457L14.5 20.054Z" fill="currentColor"/><Path d="M16 20.0406L22 18.0406V3.45947L16 5.45947L16 20.0406Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMap;
